var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreenGiftWithBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14375_4279)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 23,
    r: 23,
    fill: "#7FFAA1",
    fillOpacity: 0.18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3492 23.5012C30.2073 23.5012 30.0636 23.4954 29.9198 23.4839C27.9811 23.3191 25.9935 23.2252 23.9906 23.2031V32.9829C23.9906 33.0155 23.9887 33.0481 23.9858 33.0797C25.7511 33.0395 27.5144 32.8852 29.2672 32.6178C30.2936 32.4606 31.1379 31.6882 31.4168 30.6494C31.9141 28.795 32.1068 25.7465 31.987 23.2367C31.4714 23.4101 30.9194 23.5012 30.3492 23.5012Z",
    fill: "#7FFAA1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0903 23.2031C20.0884 23.2261 18.1027 23.321 16.1726 23.4868C16.0212 23.4992 15.8717 23.506 15.7232 23.506C15.1568 23.506 14.6077 23.4159 14.094 23.2424C13.9742 25.7504 14.1678 28.796 14.6642 30.6494C14.9431 31.6873 15.7874 32.4606 16.8137 32.6178C18.5665 32.8861 20.3299 33.0395 22.0951 33.0797C22.0922 33.0481 22.0903 33.0155 22.0903 32.9829V23.2031Z",
    fill: "#7FFAA1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0115 18.7773L32.9358 18.5128C32.6646 17.613 31.7493 16.9268 30.6559 16.8051C30.6041 16.7993 30.5514 16.7936 30.4987 16.7878C30.5073 16.6767 30.5112 16.5655 30.5112 16.4534C30.5112 13.9981 28.5131 12 26.0578 12C24.8953 12 23.8354 12.4475 23.0419 13.1797C22.2484 12.4475 21.1885 12 20.0261 12C17.5708 12 15.5727 13.9981 15.5727 16.4534C15.5727 16.5665 15.5775 16.6795 15.5851 16.7917C15.5315 16.7974 15.4788 16.8032 15.4251 16.8089C14.3316 16.9316 13.4164 17.6187 13.1471 18.5176L13.0714 18.7812C12.8702 19.5114 13.1002 20.2829 13.6857 20.8445C14.2118 21.3495 14.9431 21.6274 15.7241 21.6274C15.818 21.6274 15.9129 21.6236 16.0078 21.615C18.0001 21.4444 20.0423 21.3476 22.0913 21.3246V16.4179H23.9916V21.3246C26.0406 21.3466 28.0837 21.4425 30.0761 21.6121C30.9616 21.683 31.8088 21.407 32.3991 20.8406C32.9837 20.279 33.2127 19.5076 33.0115 18.7773ZM18.4467 16.4524C18.4467 15.5823 19.1549 14.874 20.0251 14.874C20.8751 14.874 21.5709 15.5669 21.6025 16.4093C20.5445 16.4304 19.4913 16.4745 18.4496 16.5425C18.4477 16.5128 18.4467 16.4831 18.4467 16.4524ZM26.0578 14.874C26.928 14.874 27.6362 15.5823 27.6362 16.4524C27.6362 16.4821 27.6362 16.5109 27.6343 16.5396C26.5926 16.4725 25.5384 16.4285 24.4804 16.4083C24.512 15.566 25.2078 14.874 26.0578 14.874Z",
    fill: "#7FFAA1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14375_4279"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenGiftWithBg);
export default __webpack_public_path__ + "static/media/green-gift-with-bg.f51be468f729aa2fb8ed9920896b2310.svg";
export { ForwardRef as ReactComponent };